import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { AbilitiesMap } from '@core/abilities-data';
import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';

/* NOTE: these selectors should be a part of candidate lib and imported
directly into the container component from '@recruitee/candidate/data`*/

const candidateBaseSelector = createFeatureSelector('candidate');
const candidateDataSelector = createSelector(
  candidateBaseSelector,
  (state: any) => state.dialog.candidate.data,
);

// TODO: refactor types
// due to lack of exports, I'm leaving this as any but CandidateDialog after destroy would emit null
const candidateTagsSelector = createSelector(candidateDataSelector, (state: any): string[] =>
  state ? state.tags : [],
);
const candidateSourcesSelector = createSelector(candidateDataSelector, (state: any): string[] =>
  state ? state.sources : [],
);

const editableAttrAdapter = (abilitiesMap: AbilitiesMap, attributes: string[]) => ({
  editable: abilitiesMap[Ability.ManageCandidates],
  writable: abilitiesMap[Ability.ManageAttributes],
  value: attributes.map(attr => ({ value: attr, processing: false })),
  editing: false,
  saving: false,
});
export const editableTagsSelector = createSelector(
  AbilitiesSelectors.abilityMap,
  candidateTagsSelector,
  editableAttrAdapter,
);
export const editableSourcesSelector = createSelector(
  AbilitiesSelectors.abilityMap,
  candidateSourcesSelector,
  editableAttrAdapter,
);

export const candidateIdSelector = createSelector(candidateDataSelector, (state: any) => state.id);
